module.exports = __webpack_public_path__ + "img/payment-methods-copy.ac94eb82.jpg";